module.exports = __webpack_public_path__ + "0905b5e224355e3add3278ca20478603.png";